<template>
  <article class="startup-documents">
    <ExternalLinkButton 
      target="_blank" 
      :href="statute" 
      v-if="statute"
    >
      Estatuto
    </ExternalLinkButton>
    <ExternalLinkButton 
      target="_blank" 
      :href="reformsStatute" 
      v-if="reformsStatute"
    >
      Reformas estatuto
    </ExternalLinkButton>
    <ExternalLinkButton 
      target="_blank" 
      :href="initialActionsRegister" 
      v-if="initialActionsRegister"
    >
      Registro de acciones inicial
    </ExternalLinkButton>
    
    <div class="section" v-for="(documentBlock, i) in documentBlocks" :key="i">
      <h4>{{documentBlock[0]}}</h4>
      <ExternalLinkButton
        :href="documentLink.value"
        target="_blank"
        v-for="(documentLink, i) in documentBlock[1]"
        :key="i"
      >{{documentLink.name}}</ExternalLinkButton>
    </div>
  </article>
</template>

<script>
import ExternalLinkButton from './Button/ExternalLinkButton.vue';

export default {
  name: 'StartupDocumentsInfo',
  components: {
    ExternalLinkButton,
  },
  props: {
    otherDocuments: Array,
    statute: String,
    reformsStatute: String,
    initialActionsRegister: String,
  },
  computed: {
    documentBlocks() {
      return this.otherDocuments.reduce((acc, curr) => {
        const val = acc.get(curr.type);
        return acc.set(curr.type, val ? [...val, curr] : [curr]);
      }, new Map());
    },
  },
};
</script>

<style scoped lang="scss">
h4 {
  font-size: 12px;
  color: #979797;
  margin: 0;
  font-weight: 300;
  line-height: 1.5;
  margin-top: 50px;
}
</style>
